export default __webpack_public_path__ + "static/media/clive-christian-layering.b278f66c.jpg";